import "./index.css";
import React, { useState, useEffect } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { AccountInfoProvider } from "./utils/AccountInfoContext";
import HomePage from "./HomePage";

import PlatinumSettingsPage from "./PlatinumSettingsPage";
import DreamStream from "./DreamStream";
import ReviewAddress from "./components/ReviewAddress";
import ReviewEmail from "./components/ReviewEmail";
import ReviewBankInfo from "./components/ReviewBankInfo";
import ReviewW9Info from "./components/ReviewW9Info";
import AllSet from "./components/AllSet";
import AddressesPage from "./AddressesPage";
import CreditCards from "./CreditCards";
import EmergencyContacts from "./EmergencyContacts";
import LanguagePage from "./LanguagePage";
import ManagementTeam from "./ManagementTeam";
import HomeSitePage from "./HomeSitePage";
import MembershipPage from "./MembershipPage";
import AppListPage from "./AppListPage";
import NotificationSettingsPage from "./NotificationSettingsPage";
import WWGNews from "./WWGNews";
import PersonalPage from "./PersonalPage/PersonalPage";
import { VerifyPopUp } from "./VerifyPopUp/VerifyPopUp";
import { VerifySubEntityPopUp } from "./VerifySubEntityPopUp/VerifySubEntityPopUp";
import { TCPopUp } from "./TCPopUp/TCPopUp";
import { ActivityPopUp } from "./ActivityPopUp/ActivityPopUp";
import { ConsentPopUp } from "./ConsentPopUp/ConsentPopUp";
import PrivacyPage from "PrivacyPage";
import TopicsPage from "TopicsPage";
import AccountIssuesPage from "AccountIssuesPage";

import CheckIssuesPage from "./CheckIssuesPage";
import ReceiptPage from "./ReceiptPage";

import CollectExample from "CollectExample";
import CommunicationPage from "CommunicationPage";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AccountInfoProvider>
        <Router>
          <Switch>
            <Route exact path="/">
              <HomePage />
            </Route>

            <Route path="/user/:userId">
              <HomePage />
            </Route>

            <Route path="/platinum-settings" component={PlatinumSettingsPage} />
            <Route path="/review-address/:id" component={ReviewAddress} />
            <Route path="/review-email/:id" component={ReviewEmail} />
            <Route path="/review-bank-info/:id" component={ReviewBankInfo} />
            <Route path="/review-w9/:id" component={ReviewW9Info} />

            <Route path="/all-set" component={AllSet} />
            <Route path="/addresses">
              <AddressesPage />
            </Route>
            <Route path="/addresses/edit/:iboAddressId">
              <AddressesPage />
            </Route>
            <Route path="/credit-cards">
              <CreditCards />
            </Route>
            <Route path="/dreamstream">
              <DreamStream />
            </Route>
            <Route path="/emergency-contacts">
              <EmergencyContacts />
            </Route>
            <Route
              path="/emergency-contacts/edit/:contactId"
              component={EmergencyContacts}
            />
            <Route path="/homesite">
              <HomeSitePage />
            </Route>
            <Route path="/language">
              <LanguagePage />
            </Route>
            <Route path="/management-team">
              <ManagementTeam />
            </Route>
            <Route path="/membership">
              <MembershipPage />
            </Route>
            <Route path="/applist-settings">
              <AppListPage />
            </Route>
            <Route path="/notification-settings">
              <NotificationSettingsPage selectedView="IBO" />
            </Route>
            <Route path="/wwg-news">
              <WWGNews />
            </Route>
            <Route path="/personal">
              <PersonalPage />
            </Route>
            {/* <Route path="/privacy">
              <PrivacyPage />
            </Route> */}
            <Route path="/communication">
              <CommunicationPage />
            </Route>
            <Route path="/verify">
              <VerifyPopUp />
            </Route>
            <Route path="/sub-entity-alert">
              <VerifySubEntityPopUp />
            </Route>
            <Route path="/tc">
              <TCPopUp />
            </Route>
            <Route path="/activity">
              <ActivityPopUp />
            </Route>
            <Route path="/consent">
              <ConsentPopUp />
            </Route>
            <Route path="/account-issues">
              <AccountIssuesPage />
            </Route>

            <Route exact path="/receipt/:type/:referenceId">
              <ReceiptPage />
            </Route>

            <Route path="/collect-example">
              <CollectExample />
            </Route>
            <Route path="/topics">
              <TopicsPage />
            </Route>
          </Switch>
        </Router>
      </AccountInfoProvider>
    </QueryClientProvider>
  );
}

export default App;
